export const apiDomain = 'http://localhost:5600';
